var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OverviewTemplate',{attrs:{"overview-routes":_vm.componentRoutes}},[_c('div',{attrs:{"slot":"topic"},slot:"topic"},[_vm._v("Component")]),_c('ComponentMarkdown',{attrs:{"slot":"markdown"},slot:"markdown"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }